var NProgress = require('nprogress');
var Backbone = require('backbone');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetAllEntityLookups = require('../../common/services/GetAllEntityLookups');

var COCEntityNewView = require('../views/COCEntityNewView');

module.exports = function() {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetAllEntityLookups())
    .done(function(lookups) {
      NavUtils.navigate('coc/entity/new');

      Scaffold.content.show(
        new COCEntityNewView({
          model: new Backbone.Model({
            entityTypes: lookups.entityTypes,
            organizationTypes: lookups.organizationTypes
          })
        })
      );

      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
